import _ from 'underscore';

angular.module('am4')
.factory('subscriptionService', function($http, $q, $translate, orgFacService, apiUrl) {
    return {
        getFacilitySubscribers: function(fac_id) {
            return $http.get(apiUrl + '/facilities/' + fac_id + '/subscriptions')
            .then(function(res) {
                return res.data;
            });
        },
        getOrganizationSubscribers: function(org_id) {
            return $http.get(apiUrl + '/organizations/' + org_id + '/subscriptions')
            .then(function(res) {
                return res.data;
            });
        },
        getMachineSubscribers: function(frame_serial) {
            return $http.get(apiUrl + '/machines/' + frame_serial + '/subscriptions')
            .then(function(res) {
                return res.data;
            });
        },
        getUserSubscriptions: function(user_id) {
            return $http.get(apiUrl + '/users/' + encodeURIComponent(user_id) + '/subscriptions')
            .then(function(res) {
                return res.data;
            });
        },
        createUserSubscription: function(user_id, subscription_data) {
            return $http.post(apiUrl + '/users/' + encodeURIComponent(user_id) + '/subscriptions', subscription_data)
            .then(function(res) {
                return res.data;
            });
        },
        deleteUserSubscription: function(user_id, subscription_id) {
            return $http.delete(apiUrl + '/users/' + encodeURIComponent(user_id) + '/subscriptions/' + subscription_id)
            .then(function(res) {
                return res.data;
            });
        },
        deleteOrganizationSubscriptions: function(organization_id) {
            return $http.delete(apiUrl + '/organizations/' + organization_id + '/subscriptions/');
        },
        deleteFacilitySubscriptions: function(facility_id) {
            return $http.delete(apiUrl + '/facilities/' + facility_id + '/subscriptions/');
        },
        updateUserSubscriptions: function(user_id, subscriptions) {
            return $http.put(apiUrl + '/users/' + encodeURIComponent(user_id) + '/subscriptions', subscriptions)
            .then(function(res) {
                return res.data;
            });
        },
        getAvailableSubscriptions: function(user) {

            var availableSubscriptions = {
                types: [],
                names: {
                    organization: {},
                    facility: {}
                },
                eventType: ['error']
            };

            return $q.all([orgFacService.getOrganizationsDictionary( { userId: user.user_id } ), orgFacService.getFacilitiesDictionary( { userId: user.user_id } )])
            .then(function(res) {
                availableSubscriptions.names.organization = res[0];
                availableSubscriptions.names.facility = res[1];

                if (availableSubscriptions.names.organization && !_.isEmpty(availableSubscriptions.names.organization)) {
                    availableSubscriptions.types.push(
                        {
                            value: 'organization',
                            display: $translate.instant('ORGANIZATION')
                        }
                    );
                }
                if (availableSubscriptions.names.facility && !_.isEmpty(availableSubscriptions.names.facility)) {
                    availableSubscriptions.types.push(
                        {
                            value: 'facility',
                            display: $translate.instant('FACILITY')
                        }
                    );
                }
                return availableSubscriptions;
            });
        },
        formatWithNames: function(subscriptions) {
            return $q.all([orgFacService.getOrganizationsDictionary(), orgFacService.getFacilitiesDictionary()]).then(function(res) {
                var orgDict = res[0],
                    facDict = res[1];

                subscriptions.forEach(function(subscription, index) {
                    if (subscription.facility_id) {
                        subscription.type = 'facility';
                        subscription.fac_org_id = subscription.facility_id;
                        subscription.facility_name = facDict[subscription.facility_id];
                        subscription.fac_org_name = subscription.facility_name;
                    } else if (subscription.organization_id) {
                        subscription.type = 'organization';
                        subscription.fac_org_id = subscription.organization_id;
                        subscription.organization_name = orgDict[subscription.organization_id];
                        subscription.fac_org_name = subscription.organization_name;
                    } else {
                        subscriptions.splice(index, 1);
                    }
                });
                return subscriptions;
            });
        }
    };
});



// WEBPACK FOOTER //
// ./src/app/services/subscription.js